<template>
    <nio-modal
        name="sendMassSms"
        size="md"
        :title="$t('contacts.sendMassSmsModal.title')"
        ref="modal"
        @closed="onClosed"
    >
        <message-builder
            :initial-message.sync="message"
            :selected-items="selectedContacts"
            ref="messageBuilder"
        />

        <template #footer>
            <nio-button :disabled="sending" @click="close">
                {{ $t('contacts.sendMassSmsModal.cancel') }}
            </nio-button>
            <nio-button
                color="blue"
                :disabled="!valid"
                :loading="sending"
                @click="onSend"
            >
                {{ $t('global.general.send') }}
            </nio-button>
        </template>
    </nio-modal>
</template>

<script>
    import { mapState } from 'vuex';
    import MessageParsing from '@/mixins/MessageParsing.js';
    import MessageBuilder from '@/components/MessageBuilder.vue';

    export default {
        components: {
            MessageBuilder,
        },

        mixins: [MessageParsing],

        data() {
            return {
                sending: false,
                message: {
                    fr: '',
                    en: '',
                },
            };
        },

        computed: {
            ...mapState([
                'authUser',
            ]),

            ...mapState('campaign', {
                selectedCampaign: state => state.selectedCampaign,
                selectedCampaignContacts: state => state.selectedContacts,
            }),

            ...mapState('contact', {
                contacts: state => state.selectedContacts,
            }),

            selectedContacts() {
                if (!empty(this.selectedCampaignContacts)) {
                    return this.selectedCampaignContacts;
                }

                return this.contacts;
            },

            valid() {
                return !empty(this.message.fr) || !empty(this.message.en);
            },

            isCampaign() {
                return !!this.selectedCampaign && !!this.selectedCampaign.id;
            },
        },

        methods: {
            async onSend() {
                this.sending = true;

                this.message = this.duplicateTranslationIfEmpty(this.message);

                try {
                    if (this.isCampaign) {
                        await this.sendCampaign();
                    } else {
                        await this.sendMassSms();
                    }

                    this.sending = false;

                    this.$emit('confirm');

                    this.close();

                    this.$notify.show({
                        type: 'success',
                        message: this.$t('contacts.sendMassSmsModal.sending'),
                    });
                } catch (error) {
                    this.sending = false;

                    this.close();

                    this.$notify.show({
                        type: 'error',
                        message: error.response.status === 422 ? error.response.data.message : this.$t('chat.messageInput.sendingFailed'),
                    });
                }
            },

            async sendMassSms() {
                const messages = this.selectedContacts.map(contact => {
                    let conversation = null;

                    if (!empty(contact.conversations)) {
                        conversation = contact.conversations.find(c => {
                            return c.users.filter(u => u.id == this.authUser.id);
                        });
                    }

                    const obj = conversation || contact;

                    return {
                        body: this.fillTemplateValues(this.message[contact.locale], obj),
                        conversation_id: conversation ? conversation.id : null,
                        contact_id: conversation ? null : contact.id,
                    };
                });

                await this.$axios.post('messages/mass-send', {
                    account_id: this.authUser.account.id,
                    messages,
                    type: 'sms',
                });
            },

            async sendCampaign() {
                await this.$axios.post('messages/send-campaign', {
                    message: this.message,
                    campaign_id: this.selectedCampaign.id,
                });
            },

            close() {
                this.$refs.modal.close();
            },

            onClosed() {
                this.$reset();
            },
        },
    };
</script>
